import React from 'react';
import {Redirect, Route, Switch} from 'react-router-dom';
import RangeUserFeeReport from '../../../../containers/RangeUserFeeReport';

const UserFee = ({match}) => (
  <div className="dashboard-wrapper">
    <Switch>
      <Redirect exact from={`${match.url}/`} to={`${match.url}/list`}/>
      <Route path={`${match.url}/list`} component={RangeUserFeeReport}/>
      <Redirect to="/error"/>
    </Switch>
  </div>
);

export default UserFee;
